<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">Edit Company
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>

<hr class="my-0">

<mat-dialog-content>
    <form [formGroup]="companyForm">

        <table class="table editTable">
            <tr>
                <td class="w-2/4 px-3">
                    Company Short Name
                </td>
                <td class="w-2/4 px-3">
                    Company Long Name
                </td>
            </tr>
            <tr>
                <td class="px-3">
                    <mat-form-field class="w-full">
                        <input matInput placeholder="" formControlName="companyShortName">
                        <mat-error *ngIf="companyShortName.invalid">
                            Company Short Name is required
                        </mat-error>
                    </mat-form-field>
                </td>
                <td class="px-3">
                    <mat-form-field class="w-full">
                        <input matInput placeholder="" formControlName="companyLongName">
                        <mat-error *ngIf="companyLongName.invalid">
                            Company Long Name is required
                        </mat-error>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td class="w-2/4 px-3">
                    Location
                </td>
                <td class="w-2/4 px-3">
                    Region
                </td>
            </tr>
            <tr>
                <td class="px-3">
                    <mat-form-field class="w-full">
                        <input matInput placeholder="" formControlName="location">
                        <mat-error *ngIf="location.invalid">
                            Company Location is required
                        </mat-error>
                    </mat-form-field>
                </td>
                <td class="px-3">
                    <mat-form-field class="w-full">
                        <input matInput placeholder="" formControlName="country">
                        <mat-error *ngIf="country.invalid">
                            Company Region is required
                        </mat-error>
                    </mat-form-field>
                </td>
            </tr>
            <tr>
                <td class="w-2/4 px-3">
                    Remark
                </td>
            </tr>

            <tr>
                <td class="px-3">
                    <mat-form-field class="w-full">
                        <input matInput placeholder="" formControlName="remarks">
                    </mat-form-field>
                </td>
            </tr>
        </table>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-4" mat-dialog-close>Cancel</button>
    <button class="btn btn-primary" [disabled]="companyForm.invalid" (click)="updateCompany()">
        <span *ngIf="isLoading" class="loading loading-ring loading-sm"></span>
        {{ isLoading ? 'Updating..' : 'Update' }}
    </button>
</mat-dialog-actions>

<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>